import { FindManyProfessionDocument } from '@/types/graphql/types'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

function useProfessionList({
  showSpecialties = true,
}: {
  showSpecialties?: boolean
}) {
  //fetch professions data
  const { data, ...rest } = useQuery(FindManyProfessionDocument)
  const list = useMemo(
    () =>
      data?.findManyProfession.flatMap(p => [
        {
          id: !showSpecialties ? p.id : p.id + 0.1,
          titleAr: p.titleAr,
          titleEn: p.titleEn,
          isProfession: true,
          professionId: p.id,
          specialtiesIds: p.Specialties.map(s => s.id),
        },
        ...(showSpecialties
          ? p.Specialties.map(s => ({
              id: s.id,
              titleAr: s.titleAr,
              titleEn: s.titleEn,
              isProfession: false,
              professionId: p.id + 0.1,
            }))
          : []),
      ]) || [],
    [data],
  )
  return {
    professionList: list,
    ...rest,
  }
}

export default useProfessionList
